import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  copy?: string;
  align?: "left" | "center";
  light?: boolean;
  className?: string;
  id?: string;
};
function SectionHeading({
  eyebrow,
  title,
  copy,
  align = "left",
  light = false,
  className = "",
  id
}: SectionHeadingProps) {
  return <div className={`${align === "center" ? "mx-auto text-center" : ""} max-w-3xl ${className}`} data-id="element-445" data-mp="363cioyhyzdlc">
      {eyebrow ? <p className={`section-label mb-4 ${light ? "text-pfpc-orange" : "text-pfpc-steel"}`} data-id="element-446" data-mp="3b1e3poyyhmzg">
          {eyebrow}
        </p> : null}
      <h2 id={id} className={`font-heading text-[30px] font-extrabold leading-[1.15] md:text-[40px] md:leading-[1.12] ${light ? "text-pfpc-offwhite" : "text-pfpc-navy"}`} data-id="element-447" data-mp="3ju7yyvusswyy">
        {title}
      </h2>
      {copy ? <p className={`mt-5 max-w-[68ch] text-[17px] leading-7 md:text-lg md:leading-8 ${light ? "text-pfpc-offwhite/75" : "text-pfpc-navy/72"}`} data-id="element-448" data-mp="3tsx5jsh8uuzw">
          {copy}
        </p> : null}
    </div>;
}
export { SectionHeading };